export const PdfLoadingIndicator = () => <>@@@LOADING@@@</>
